import { cn } from "@/lib/utils";

export const AI_DISCLAIMER_TEXT = "Ordinal can make mistakes. Check important info.";

// Shared AI-limitations disclaimer rendered on every surface that displays
// AI-generated content (AI Governance Policy: public-facing AI language must
// describe known limitations).
const AiDisclaimer = ({ className }: { className?: string }) => {
  return <p className={cn("text-xs text-muted-foreground", className)}>{AI_DISCLAIMER_TEXT}</p>;
};

export default AiDisclaimer;
